import React, { useContext, useState } from 'react';
import { setPin, removePin } from '../../../../../common/services/http/documentsService';
import { downloadDoc } from '../../../../../common/services/http/documentsService';
import Icon from '../../../../ui/icon/icon';
import Pin from '../../../../ui/button/pin/pin';
import LoadingCell from '../../../../ui/table/cells/loadingCell/loadingCell';
import DocsCtx from '../../../../../context/docsContext/docsCtx';
import useTranslate from '../../../../../common/hooks/useTranslate';

import './actionsCell.scss';

const ActionsCell = (props) => {
  const [pinned, setPinned] = useState<boolean | undefined>(props.dataItem.isPinned);

  const docsCtx = useContext(DocsCtx);
  const { t } = useTranslate();

  let displayDocNumber = '';

  if (props.rowType === 'groupHeader') {
    return null;
  }

  if (props.dataItem['documentId'] === undefined && props.treelist) {
    let docLabel = '';
    let folderLabel = '';
    if (props.dataItem.children) {
      docLabel = props.dataItem.children.length > 1 ? t('DOCUMENTS_TABLE.LABEL_DOCUMENTS') : t('DOCUMENTS_TABLE.LABEL_DOCUMENT');
      folderLabel = props.dataItem.children.length > 1 ? t('DOCUMENTS_TABLE.LABEL_FOLDERS') : t('DOCUMENTS_TABLE.LABEL_FOLDER');
    }

    if (!props.isDocNumberShown) {
      displayDocNumber = 'treelist-header-cell noDisplay';
    } else {
      displayDocNumber = 'treelist-header-cell';
    }
    return (
      <td className={displayDocNumber}>
        {props.dataItem.children && <span>{`${props.dataItem.children.length} ${props.dataItem.children[0]['documentId'] ? docLabel : folderLabel}`}</span>}
      </td>
    );
  }

  if (props.dataItem['documentId'] === undefined) return <LoadingCell />;

  const isCheckedDocId = docsCtx.selectedItemsDocIds && docsCtx.selectedItemsDocIds.indexOf(props.dataItem['documentId']);
  const isCheckedId = docsCtx.selectedItemsIds && docsCtx.selectedItemsIds.indexOf(props.dataItem['id']);

  const handleCheck = () => {
    if (isCheckedId !== -1) {
      props.onUncheck(props.dataItem.documentId, props.dataItem.id);
    } else if (isCheckedId === -1 && isCheckedDocId !== -1) {
      props.onCheck(props.dataItem.documentId, props.dataItem.id);
    } else {
      props.onCheck(props.dataItem.documentId, props.dataItem.id);
    }
  };

  const handlePinClick = () => {
    if (pinned === false) {
      setPin(+props.dataItem.id).then(() => {
        setPinned(true);
      });
    } else if (pinned === true) {
      removePin(+props.dataItem.id).then(() => {
        setPinned(false);
      });
    }
  };

  const handleDownload = () => {
    downloadDoc(props.dataItem);
  };

  return (
    <td className="action-cell-td" style={{ width: props.width }}>
      <div className="actions-cell">
        <Icon className="actions-cell-icon" name={`${isCheckedId !== -1 ? 'fas fa-check-square' : 'far fa-square'}`} onClick={handleCheck} />
        <Icon className="actions-cell-icon" name={'far fa-file-download'} disabled={props.multipleDownload && isCheckedId !== -1} onClick={handleDownload} />
        <Pin isPinned={pinned} clickHandler={handlePinClick} className={'actions-cell-icon'} />
      </div>
    </td>
  );
};

export default ActionsCell;
